module.exports = __webpack_public_path__ + "fe09af91e3e35391d1d4e3c5aed4f378.pdf";